<template>
  <div class="date-field-wrapper" :class="{ 'date-field--danger': state === 'danger' }">
    <img :src="iconSrc" alt="calendar" class="date-left-icon" />
    <DatePicker
      v-model="model"
      :format="'YYYY-MM-DD'"
      :editable="false"
      :input-attr="{ placeholder: placeholder }"
      :disabled-date="disabledDate"
      :clearable="false"
      :default-value="defaultDateValue"
      value-type="format"
    />
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  name: 'DateField',
  components: { DatePicker },
  props: {
    value: { type: String, default: '' },        // expects 'YYYY-MM-DD'
    placeholder: { type: String, default: '' },
    min: { type: String, default: undefined },   // expects 'YYYY-MM-DD'
    state: { type: String, default: undefined }  // e.g. 'danger'
  },
  computed: {
    model: {
      get() {
        return this.value || ''
      },
      set(val) {
        this.$emit('input', val || '')
      }
    },
    iconSrc() {
      return require('../../assets/icons/input/date.png')
    },
    defaultDateValue() {
      // Return current date as default value for calendar
      // This ensures the calendar opens at the current month
      return new Date().toISOString().split('T')[0]
    }
  },
  methods: {
    disabledDate(date) {
      if (!this.min) return false
      try {
        const d = new Date(date)
        d.setHours(0, 0, 0, 0)
        const min = new Date(this.min + 'T00:00:00')
        min.setHours(0, 0, 0, 0)
        return d < min
      } catch (e) {
        return false
      }
    }
  }
}
</script>

<style scoped>
.date-field-wrapper {
  width: 100%;
  position: relative;
}

/* Danger state styling to mimic validation feedback */
.date-field--danger :deep(.mx-input) {
  border-color: #e24c4c !important;
  box-shadow: 0 0 0 1px rgba(226, 76, 76, 0.2) !important;
}

/* Ensure consistent sizing */
:deep(.mx-input) {
  height: 44px;
  font-size: 16px;
  width: 100%;
  /* room for our left icon */
  padding-left: 38px !important;

  /* remove outline/ring */
  outline: none !important;
  box-shadow: none !important;
}
:deep(.mx-input:focus),
:deep(.mx-input:hover),
:deep(.mx-input:focus-within) {
  outline: none !important;
  box-shadow: none !important;
}
/* also ensure wrapper doesn't add ring */
:deep(.mx-datepicker:focus-within) {
  outline: none !important;
  box-shadow: none !important;
}
/* hide default clear icon if any (extra safety) */
:deep(.mx-datepicker .mx-icon-clear) {
  display: none !important;
}
/* hide default calendar icon on the right */
:deep(.mx-datepicker .mx-icon-calendar) {
  display: none !important;
}

/* our left calendar icon */
.date-left-icon {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  pointer-events: none;
  opacity: 0.9;
}
</style>

<style>
.mx-datepicker {
  width: calc(100% - 40px)!important
}
</style>